import { render, staticRenderFns } from "./Wavesurfer.vue?vue&type=template&id=e0fc1c1a&scoped=true&"
import script from "./Wavesurfer.vue?vue&type=script&lang=js&"
export * from "./Wavesurfer.vue?vue&type=script&lang=js&"
import style0 from "./Wavesurfer.vue?vue&type=style&index=0&id=e0fc1c1a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fc1c1a",
  null
  
)

export default component.exports